import BaseService, { IHttpResponse } from '../../../BaseService';
import TokensService from '../../../TokensService/TokensService';
import { IPrepareMediaPlaysUrl, prepareMediaPlaysUrl } from '../BuildUrls';
import { IMediaPlays } from '../Types';

const debug = require('debug')(
  'tca:service:MediaPersonalizationService:MediaPlayService:Core:Create'
);

export enum MEDIA_FORMAT {
  AUDIO = 'audio',
  VIDEO = 'video',
}

export interface IMediaPlayCreateBody {
  app_key: string;
  duration_ms?: number;
  last_media_format: MEDIA_FORMAT;
  play_count?: number;
  progress_ms?: number;
  _embedded: {
    'media-item': {
      id: string;
    };
    'end-user': {
      id: string;
    };
  };
}

interface IMediaPlaysCreate extends IPrepareMediaPlaysUrl {
  appKey?: string;
  data: IMediaPlayCreateBody;
}

interface IMediaPlaysCreateResponse extends IHttpResponse {
  body?: IMediaPlays;
}

export default async function Create({
  appKey,
  data,
  ...buildUrlProps
}: IMediaPlaysCreate): Promise<IMediaPlaysCreateResponse> {
  debug('Create');
  const token = await TokensService.getGuestToken();
  const url = prepareMediaPlaysUrl(buildUrlProps);

  return BaseService.Post({
    url,
    appKey,
    token,
    data,
  });
}
